export enum AssetMeterPriceStatus {
  Active = 0,
  Inactive = 1,
}

export class AssetMeterPrice {
  id: number = 0;
  utilityId: number = 0;
  name: string = '';
  organizationId: number | undefined;
  meterBrandId: number | undefined;
  meterModelId: number | undefined;
  assetMeterTypeId: number | undefined;
  meterPrice: number | undefined;
  status: AssetMeterPriceStatus | undefined;
}
